<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div *ngIf="!company" id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
    <!--begin::Page title-->
    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading"><svg width="33" height="33" viewBox="0 0 33 33" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_243_2406)">
              <path
                d="M25.192 19.9315C25.7393 19.5037 26.0985 18.8399 26.0985 18.0868C26.0985 16.7978 25.0636 15.749 23.7915 15.749C22.6442 15.749 21.6975 16.6046 21.5214 17.7177H16.3849V12.55H18.9347H21.8488C22.0499 12.55 22.2131 12.3847 22.2131 12.1809C22.2131 9.32093 20.313 6.90664 17.7264 6.15356C18.6676 5.56913 19.299 4.52029 19.299 3.32207C19.299 1.49017 17.8282 0 16.0206 0C14.2131 0 12.7423 1.49017 12.7423 3.32207C12.7423 4.52029 13.3737 5.56913 14.3148 6.15356C11.7282 6.90664 9.82818 9.32093 9.82818 12.1809C9.82818 12.3847 9.99134 12.55 10.1924 12.55H13.1065H15.6564V17.7177H10.5199C10.3437 16.6046 9.39705 15.749 8.24972 15.749C6.97765 15.749 5.94273 16.7978 5.94273 18.0868C5.94273 18.8399 6.30192 19.5037 6.84929 19.9315C5.19289 20.5199 4 22.1159 4 23.9927C4 24.1965 4.16316 24.3618 4.36426 24.3618H6.30699H10.1924H12.1352C12.3363 24.3618 12.4994 24.1965 12.4994 23.9927C12.4994 22.1159 11.3065 20.5199 9.65014 19.9315C10.1056 19.5755 10.4249 19.0559 10.5199 18.4559H16.0206H21.5214C21.6163 19.0559 21.9356 19.5755 22.3911 19.9315C20.7347 20.5199 19.5418 22.1159 19.5418 23.9927C19.5418 24.1965 19.705 24.3618 19.9061 24.3618H21.8488H25.7343H27.677C27.8781 24.3618 28.0413 24.1965 28.0413 23.9927C28.0413 22.1159 26.8484 20.5199 25.192 19.9315Z"
                fill="#265D91" />
            </g>
            <defs>
              <filter id="filter0_d_243_2406" x="0" y="0" width="32.043" height="32.3618" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_243_2406" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_243_2406" result="shape" />
              </filter>
            </defs>
          </svg>


          Intervenant
        </h1>

      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/accueil" class="text-muted ">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Nos intervenants</li>


        <!-- <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        <li class="breadcrumb-item text-muted">Liste des intervenants</li> -->

        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>
<div id="kt_app_content_container" class="app-container container-fluid">
  <!--begin::Card-->
  <div class="card mb-10" *ngIf="!company">
    <div class="card-body tools" [formGroup]="searchFormGroup" >
      <div class="title mb-5">
        <h4>Recherche</h4>
      </div>
      <div class="row mb-3">
        <div class="col-lg-3">
          <input type="text" name="id" id="id" class="form-control form-control-solid mb-3" formControlName="name"
            placeholder="Nom et prénom">
        </div>
        <div class="col-lg-3 mb-3">
              <!--begin::Input-->
            <ng-select formControlName="role" [items]="listRole" bindLabel="name" bindValue="name" [notFoundText]="'Aucun élément trouvé'"
              [placeholder]="'Rôle'" ></ng-select>
        </div>
        <div class="col-lg-6">
          <div class="mb-3 search-btn d-flex justify-content-end">
            <div class="align-items-center recherche">
              <button type="submit" class="me-5" (click)="applyFilter()">
                <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                    fill="white" />
                </svg>
                Rechercher</button>
            </div>
            <div class="resett-btn">
              <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                title="Réinitialiser">
                <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt="" width="30px"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin::Card header-->

    <!--end::Card header-->
    <!--begin::Card body-->

    <!--end::Card body-->
  </div>

  <div *ngIf="!isLoadSpinner" id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->

    <div class="card content-table pt-5 pb-5">
      <!--begin::Card header-->

      <div class="card-body tools">
        <div class="header mb-10 flex-wrap">
          <div class="title mb-5">
            <h4>Liste des intervenants</h4>
          </div>
          <div class="btn_search">
            <a [routerLink]="['/intervenants/ajout-intervenant']" class="search cursor-pointer"> + Ajouter un intervenant</a>
          </div>
        </div>
        <div class="filter-tools mt-15 mb-5" >
          <ul class="nav nav-pills me-5" *ngIf="listIntervenant && listIntervenant.length">
            <li class="nav-item m-0">
              <a
                class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                data-bs-toggle="tab"
                href="#kt_project_targets_card_pane"
              >
                <i class="ki-duotone ki-element-plus fs-1">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                  <span class="path5"></span>
                </i>
              </a>
            </li>
            <li class="nav-item m-0">
              <a
                class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                data-bs-toggle="tab"
                href="#kt_project_targets_table_pane"
              >
                <i class="ki-duotone ki-row-horizontal fs-2">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
              </a>
            </li>
          </ul>
        </div>

        <div class="tab-content for-web">

        <div id="kt_project_targets_card_pane" class="tab-pane fade">
            <!--begin::Row-->
            <div class="row g-6 g-xl-9 justify-content-center">
              <!--begin::Col-->
              <div
                class="col-md-6 col-xxl-4"
                *ngFor="let client of listIntervenant;let i =index"
              >
                <!--begin::Card-->
                <div class="card pt-5 p-5">
                  <div class="tools">
                    <div class="dropdown">
                      <button
                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <svg
                          width="19"
                          height="5"
                          viewBox="0 0 19 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="2.44739"
                            cy="2.44739"
                            r="2.44739"
                            transform="matrix(1 0 0 -1 0 4.89478)"
                            fill="#265D91"
                          />
                          <circle
                            cx="2.44739"
                            cy="2.44739"
                            r="2.44739"
                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                            fill="#265D91"
                          />
                          <circle
                            cx="2.44739"
                            cy="2.44739"
                            r="2.44739"
                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                            fill="#265D91"
                          />
                        </svg>
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                      <a class="dropdown-item"  [routerLink]="['/candidats/profilecandidatesn',client.uuid]"
                      style="cursor: pointer;"> Visualiser</a>

                        <a class="dropdown-item" (click)="updateNavigation(client)"
                        style="cursor: pointer;">Modifier</a>
                        <a class="dropdown-item" (click)="swallDeleteCat(client)" style="cursor: pointer;">Supprimer</a>
                      </div>
                    </div>
                  </div>
                  <!--begin::Card body-->
                  <div class="card-body d-flex flex-center flex-column">
                    <div class="symbol symbol-65px symbol-circle mb-5">
                      <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->
                      <img *ngIf="client?.image_url && client?.image_url !== 'avatar.png'" class="table-img circle-img"
                      src="{{url+'/User/file/gallery_users/' + client?.image_url}}" alt="" width="50px">
                    <img *ngIf="!client?.image_url || client?.image_url === 'avatar.png'|| client?.image_url === 'null'"
                      class="table-img circle-img" src="{{url+'/Company/file/gallery_company/avatar.png'}}" alt=""
                      width="50px">
                    </div>
                    <!--end::Avatar-->
                    <!--begin::Name-->
                    <a class="job-title first-td" [routerLink]="['/candidats/profilecandidatesn',client.uuid]">
                      {{client.first_name}}  {{client.last_name}} </a>
                      <div class="poste">
                        <span *ngIf="listRole && listRole.length > 0">
                          {{ getRoleName(client.employee_role_id ) }}
                        </span>
                      </div>
                      <div class="info">
                        <div class="type mb-3" *ngIf="client.last_connection && client.last_connection !== '0'">
                          <span>Dernière connexion :</span>
                          {{ !client.last_connection ? '---' :client.last_connection.split('
                            ')[0].split('-').reverse().join('/') }}
                        </div>
                        </div>
                    </div>
                    <div class="sep"></div>
                  <div class="foot p-5">
                    <div class="plus">
                      <a [routerLink]="['/candidats/profilecandidatesn',client.uuid]"
                      style="cursor: pointer;">Visualiser</a>  
                    </div>
                  </div>
                  <!--end::Card body-->
                </div>
                <!--end::Card-->
              </div>
              <div class="pagination mt-5 pt-5" *ngIf="listIntervenant && listIntervenant.length">
                <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                  [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                  aria-label="Select page">
                </mat-paginator>
              </div>
              <app-empty-state *ngIf="listIntervenant && !listIntervenant.length"
              [title]="parentItem"></app-empty-state>
              <!--end::Col-->
            </div>
            <!--end::Row-->
          </div>

        <div id="kt_project_targets_table_pane" class="tab-pane fade show active"
        >
          <div class="table-responsive mt-5" id="kt_customers_table"  *ngIf="listIntervenant && listIntervenant.length">
          <table class="table align-middle gy-5 style-table">
            <thead>
              <tr class="text-gray-400 text-uppercase gs-0">
                <th class="min-w-125px">
                  <span>Image</span>
                </th>
                <th class="min-w-125px th-fixed">
                  <span>Nom intervenants</span>
                <th class="min-w-125px">
                  <span>Rôle</span>
                </th>
                <th class="min-w-125px">
                  <span>Email personnel</span>
                </th>

                <th class="min-w-125px">
                  <span>Email professionnel</span>
                </th>
                <th class="min-w-125px">
                  <span>Télèphone</span>
                </th>
                <th class="min-w-200px"><span>Dernière connexion</span> </th>
                <th class="min-w-125px stiky-column-action">
                  <span>Action</span>
                </th>
              </tr>
            </thead>
            <tbody *ngFor="let client of listIntervenant;let i =index">
              <tr>
                <td>

                  <img *ngIf="client?.image_url && client?.image_url !== 'avatar.png'" class="table-img circle-img"
                    src="{{url+'/User/file/gallery_users/' + client?.image_url}}" alt="" width="50px">
                  <img *ngIf="!client?.image_url || client?.image_url === 'avatar.png'|| client?.image_url === 'null'"
                    class="table-img circle-img" src="{{url+'/Company/file/gallery_company/avatar.png'}}" alt=""
                    width="50px">

                </td>
                <td class="td-fixed"> <a class="first-td" [routerLink]="['/candidats/profilecandidatesn',client.uuid]">
                  {{client.first_name}}  {{client.last_name}} </a></td>
                <td>
                  <span *ngIf="listRole && listRole.length > 0">
                    {{ getRoleName(client.employee_role_id ) }}
                  </span>
                </td>
                <td>
                  <span>{{client.email?client.email:'---'}}</span>
                </td>
                <td>
                  <span *ngIf="typeCompany==2;">{{client.emailProESN?client.emailProESN:'---'}}</span>
                  <span *ngIf="typeCompany==3;">{{client.emailProClient?client.emailProClient:'---'}}</span>
                </td>
                <td>
                  <span>{{client.phone_number?client.phone_number:'---'}}</span>
                </td>
                <td> <span> {{ !client.last_connection ? '---' :client.last_connection.split('
                  ')[0].split('-').reverse().join('/') }}
                </span>
                </td>
                <td  class="td-fixed-3">
                  <div class="dropdown" mat-button [matMenuTriggerFor]="menu">
                    <button class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                      type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      <svg width="19" height="5" viewBox="0 0 19 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                          fill="#265D91" />
                        <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 6.85254 4.89478)"
                          fill="#265D91" />
                        <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 13.7061 4.89478)"
                          fill="#265D91" />
                      </svg>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item [routerLink]="['/candidats/profilecandidatesn',client.uuid]">
                        Visualiser
                      </button>
                      <button mat-menu-item (click)="updateNavigation(client)">
                        Modifier
                      </button>
                      <button mat-menu-item (click)="swallDeleteCat(client)" style="cursor: pointer;">
                        Supprimer
                      </button>
                    </mat-menu>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="pagination mt-5 pt-5" *ngIf="listIntervenant && listIntervenant.length">
            <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
              [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
              aria-label="Select page">
            </mat-paginator>
          </div>
          <app-empty-state *ngIf="listIntervenant && !listIntervenant.length"
          [title]="parentItem"></app-empty-state>
        </div>
        </div>

        <div class="tab-content for-mobile">
          <!--begin::Tab pane-->
          <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
            <!--begin::Row-->
            <div class="row g-6 g-xl-9 justify-content-center">
              <!--begin::Col-->
              <div
                class="col-md-6 col-xxl-4"
                *ngFor="let client of listIntervenant;let i =index"
              >
                <!--begin::Card-->
                <div class="card pt-5 p-5">
                  <div class="tools">
                    <div class="dropdown">
                      <button
                        class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <svg
                          width="19"
                          height="5"
                          viewBox="0 0 19 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="2.44739"
                            cy="2.44739"
                            r="2.44739"
                            transform="matrix(1 0 0 -1 0 4.89478)"
                            fill="#265D91"
                          />
                          <circle
                            cx="2.44739"
                            cy="2.44739"
                            r="2.44739"
                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                            fill="#265D91"
                          />
                          <circle
                            cx="2.44739"
                            cy="2.44739"
                            r="2.44739"
                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                            fill="#265D91"
                          />
                        </svg>
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                      <a class="dropdown-item"  [routerLink]="['/candidats/profilecandidatesn',client.uuid]"
                      style="cursor: pointer;"> Visualiser</a>

                        <a class="dropdown-item" (click)="updateNavigation(client)"
                        style="cursor: pointer;">Modifier</a>
                        <a class="dropdown-item" (click)="swallDeleteCat(client)" style="cursor: pointer;">Supprimer</a>
                      </div>
                    </div>
                  </div>
                  <!--begin::Card body-->
                  <div class="card-body d-flex flex-center flex-column">
                    <div class="symbol symbol-65px symbol-circle mb-5">
                      <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->
                      <img *ngIf="client?.image_url && client?.image_url !== 'avatar.png'" class="table-img circle-img"
                      src="{{url+'/User/file/gallery_users/' + client?.image_url}}" alt="" width="50px">
                    <img *ngIf="!client?.image_url || client?.image_url === 'avatar.png'|| client?.image_url === 'null'"
                      class="table-img circle-img" src="{{url+'/Company/file/gallery_company/avatar.png'}}" alt=""
                      width="50px">
                    </div>
                    <!--end::Avatar-->
                    <!--begin::Name-->
                    <a class="job-title first-td" [routerLink]="['/candidats/profilecandidatesn',client.uuid]">
                      {{client.first_name}}  {{client.last_name}} </a>
                      <div class="poste">
                        <span *ngIf="listRole && listRole.length > 0">
                          {{ getRoleName(client.employee_role_id ) }}
                        </span>
                      </div>
                      <div class="info">
                        <div class="type mb-3" *ngIf="client.last_connection && client.last_connection !== '0'">
                          <span>Dernière connexion :</span>
                          {{ !client.last_connection ? '---' :client.last_connection.split('
                            ')[0].split('-').reverse().join('/') }}
                        </div>
                        </div>
                    </div>
                    <div class="sep"></div>
                  <div class="foot p-5">
                    <div class="plus">
                      <a [routerLink]="['/candidats/profilecandidatesn',client.uuid]"
                      style="cursor: pointer;">Visualiser</a>  
                    </div>
                  </div>
                  <!--end::Card body-->
                </div>
                <!--end::Card-->
              </div>
              <div class="pagination mt-5 pt-5" *ngIf="listIntervenant && listIntervenant.length">
                <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                  [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                  aria-label="Select page">
                </mat-paginator>
              </div>
              <app-empty-state *ngIf="listIntervenant && !listIntervenant.length"
              [title]="parentItem"></app-empty-state>
              <!--end::Col-->
            </div>
            <!--end::Row-->
          </div>
        </div>

        
      </div>
    </div>
    <!--end::Content container-->
  </div>
  <ng-template #ajouter>
    <div class="modal-dialog-centered" id="ajouter" tabindex="-1" aria-hidden="true">
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class="modal-content pt-5  pb-5">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="fw-bold">Ajouter intervenant</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary">
            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body mx-5" [formGroup]="intervenantForm">
          <div class="bloc-input mb-5">
            <!--begin::Label-->

            <label class="required fs-6 fw-semibold mb-2">
              <span class="">Email personnel</span>
            </label>
            <!--end::Label-->
            <!--begin::Input-->
            <input type="email" formControlName="email" (change)="onSearch($event)"
              class="form-control form-control-solid" placeholder="Email personnel" name="email" value="" />
            <!--end::Input-->
            <div *ngIf="intervenantForm.get('email')?.hasError('required') && intervenantForm.get('email')?.touched"
              class="text-danger">
              Le champ est obligatoire.
            </div>
            <div *ngIf="intervenantForm.get('email')?.hasError('pattern') && intervenantForm.get('email')?.touched"
              class="text-danger">
              La valeur de ce champ doit avoir une adresse email valide.
            </div>
          
          </div>


          <div class="bloc-input mb-5" *ngIf="typeCompany==2;">

            <label class="fs-6 fw-semibold mb-2">
              <span class=""> Email professionnel ESN</span>
            </label>

            <!--end::Label-->
            <!--begin::Input-->
            <input type="email" formControlName="emailProESN"
              class="form-control form-control-solid" placeholder="Email professionnel esn" name="emailProESN" value="" />
            <!--end::Input-->
            <div
              *ngIf="intervenantForm.get('emailProESN')?.hasError('pattern') && intervenantForm.get('emailProESN')?.touched"
              class="text-danger">
              La valeur de ce champ doit avoir une adresse email valide.
            </div>
          </div>

          <div class="bloc-input mb-5" *ngIf="typeCompany==3;">

            <label class="fs-6 fw-semibold mb-2">
              <span class=""> Email professionnel Client</span>
            </label>

            <!--end::Label-->
            <!--begin::Input-->
            <input type="email" formControlName="emailProClient"
              class="form-control form-control-solid" placeholder="Email professionnel client" name="emailProClient" value="" />
            <!--end::Input-->
            <div
            *ngIf="intervenantForm.get('emailProClient')?.hasError('pattern') && intervenantForm.get('emailProClient')?.touched"
            class="text-danger">
            La valeur de ce champ doit avoir une adresse email valide.
          </div>
          </div>

          <div class="bloc-input mb-5">
            <label class="required fs-6 fw-semibold mb-2"> Nom</label>
            <input type="text" formControlName="first_name" class="form-control form-control-solid" placeholder="Nom"
              name="Nom" />
            <div
              *ngIf="intervenantForm.get('first_name')?.hasError('required') && intervenantForm.get('first_name')?.touched"
              class="text-danger">
              Le champ est obligatoire.
            </div>
        
        <div *ngIf="intervenantForm.get('first_name')?.hasError('pattern') && intervenantForm.get('first_name')?.touched"
        class="text-danger">
        La valeur de ce champ doit avoir un nom valide.
    </div>

          </div>
          <div class="bloc-input mb-5">
            <label class="required fs-6 fw-semibold mb-2">Prénom</label>
            <input type="text" formControlName="last_name" class="form-control form-control-solid" placeholder="Prénom"
              name="Nom" />
            <div
              *ngIf="intervenantForm.get('last_name')?.hasError('required') && intervenantForm.get('last_name')?.touched"
              class="text-danger">
              Le champ est obligatoire.
            </div>
             <div *ngIf="intervenantForm.get('last_name')?.hasError('pattern') && intervenantForm.get('last_name')?.touched"
              class="text-danger">
                 La valeur de ce champ doit avoir un prénom  valide.
               </div>
            </div>
          <div class="bloc-input mb-5">
            <label for="web">linkedin</label>
              <input type="text" name="linkedin" id="linkedin" class="form-control form-control-solid mb-3" placeholder="https://www.linkedin.com/in/" formControlName="linkedin_link" (input)="setValidatorRequirements()" >
          <!-- <div *ngIf="intervenantForm.get('linkedin_link')?.hasError('required') && intervenantForm.get('linkedin_link')?.touched" class="text-danger">
        Le champ "linkedin" est obligatoire.
          </div> -->
        <div *ngIf="intervenantForm.get('linkedin_link')?.hasError('pattern') && intervenantForm.get('linkedin_link')?.touched" class="text-danger">
              Entrer une URL valide exemple: https://www.linkedin.com/in/exemple
        </div> 
          </div>
          <div class="flex_input">
            <div class="w-100">
                <div class="labels">
                    <label for="cv" > Importer CV {{cvname}}</label>
                    <button *ngIf="showResetButtons && fileName !== '' && !iscv" class="more-label"
                    (click)="resetCV()">
                    <img src="assets/media/icons/icon-delete.png" alt="" width="30px"
                        class="cursor-pointer">
                </button>
                </div>
            </div>
            <input  *ngIf="!iscv" id="fileInput" #inputFile type="file" name="cv" id="cv" 
            (change)="uploadFile($event);setValidatorRequirements()" class="form-control mb-3">

            <input *ngIf="iscv" type="text" name="cv" id="cv" formControlName="cv"
            class="form-control mb-3" placeholder="cv" [readonly]="true" />

            <span style="color:red" *ngIf="fileError"><small>{{fileError}} </small></span>
            <span style="color:red" *ngIf="fileExtention"><small>{{fileExtention}} </small></span>
            <label>Le cv doit être (.pdf,.doc,.docx) </label><br>

      

        </div>
          
        <div *ngIf="!isexistemail" class="bloc-input mb-5">
    <label class="fs-6 fw-semibold mb-2">N° de téléphone </label>
  
    <form [formGroup]="phoneForm" class="phone-number">
   <div class="wrapper">
        <ngx-intl-tel-input [cssClass]="'form-control'"
            [searchCountryPlaceholder]="'Rechercher un pays'"
        [preferredCountries]="preferredCountries"
        [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true"
        [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
        [selectFirstCountry]="false"
        [selectedCountryISO]="CountryISO.France"
        [maxLength]="20" [phoneValidation]="true"
        [separateDialCode]="separateDialCode"
        [numberFormat]="PhoneNumberFormat.National"
        name="phone" formControlName="phone" 
        >
    </ngx-intl-tel-input>
 
    <!-- <div *ngIf="phoneForm.get('phone')?.hasError('required') && phoneForm.get('phone')?.touched" class="text-danger">
      Le champ est obligatoire.
    </div> -->
    <div *ngIf="!phoneForm.get('phone')?.hasError('required') && phoneForm.get('phone')?.invalid && phoneForm.get('phone')?.touched" class="text-danger">
      Numéro de téléphone est invalide
    </div>
    <!-- <div *ngIf="phoneForm.controls['phone'].invalid && phoneForm.controls['phone'].touched">
    <span class="text-danger">Numéro de téléphone est
        invalide</span>
      </div> -->

      </div>
    </form>
    
</div>
<div *ngIf="isexistemail && !phoneForm.get('phone')?.value"class="bloc-input mb-5">
         
  <label class="fw-semibold mb-2">N° tel</label>
  <div class="wrapper phone-number"  [formGroup]="phoneForm">
    <ngx-intl-tel-input
    [cssClass]="'form-control disabled-input'"
        [searchCountryPlaceholder]="'Rechercher un pays'"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="false" 
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false"
    [selectedCountryISO]="CountryISO.France"
    [maxLength]="10"
    [phoneValidation]="true"
    [separateDialCode]="separateDialCode"
    [numberFormat]="PhoneNumberFormat.National"
    name="phone"
    formControlName="phone"
    (mousedown)="disableEvent($event)"
    (keydown)="disableEvent($event)">
  </ngx-intl-tel-input>
  
</div>

</div>
<div *ngIf="isexistemail && phoneForm.get('phone')?.value"class="bloc-input mb-5">
         
  <label class="fw-semibold mb-2">N° tel</label>
  <div class="wrapper phone-number"  [formGroup]="phoneForm">
    <ngx-intl-tel-input
        [searchCountryPlaceholder]="'Rechercher un pays'"
    [cssClass]="'form-control disabled-input'"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="true" 
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="false"
    [selectedCountryISO]="CountryISO.France"
    [maxLength]="10"
    [phoneValidation]="true"
    [separateDialCode]="separateDialCode"
    [numberFormat]="PhoneNumberFormat.National"
    name="phone"
    formControlName="phone"
    (mousedown)="disableEvent($event)"
    (keydown)="disableEvent($event)">
  </ngx-intl-tel-input>
  
</div>

</div>
          <div class="bloc-input mb-5">
            <!--begin::Label-->
            <label class="required fs-6 fw-semibold mb-2">Rôle</label>
            <!--end::Label-->
            <!--begin::Input-->
            <ng-select formControlName="employee_role_id" [items]="listRole" bindLabel="name" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
              [placeholder]="'Rôle'" autoComplete>
            </ng-select>
            <!-- <app-feild-error [control]="intervenantForm.get('employee_role_id')"></app-feild-error> -->
            <!--end::Input-->
            <div *ngIf="intervenantForm.get('employee_role_id')?.hasError('required') && intervenantForm.get('employee_role_id')?.touched"
            class="text-danger">
            Le champ est obligatoire.
          </div>
          </div>
          <div class="bloc-input mb-5">
            <label for="fin">Date signature de contrat</label>
            <input type="date" formControlName="date_signature" id="date_signature" class="form-control mb-5">
            <div
              *ngIf="intervenantForm.get('date_signature')?.hasError('required') && intervenantForm.get('date_signature')?.touched"
              class="text-danger">
              Le champ est obligatoire.
            </div>
          </div>




          <div class="modal-footer">
            <div class="actions">
              <a (click)="closeModal()" class="annuler" style="cursor: pointer;">Annuler</a>
              <button type="submit" data-bs-dismiss="modal"
              (click)="addInterveanant()"  [disabled]="fileError||fileExtention ||
                phoneForm.get('phone')?.invalid ||intervenantForm.get('employee_role_id')?.invalid||
                intervenantForm.get('last_name')?.invalid || intervenantForm.get('first_name')?.invalid || intervenantForm.get('linkedin_link')?.invalid" class="footer-btn confirmer">
              <span class="indicator-label">Confirmer</span>
              <span class="indicator-progress">Please wait...
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
            </div>
          </div>
        

          <!--end::Modal body-->

          <!--end::Modal content-->
        </div>
        <!--end::Modal dialog-->

      </div>
    </div>
  </ng-template>

  <!-- ////////////////////////////////////////////////////////////////////////////////////// -->

  <ng-template #detail>
    <div class="modal-dialog-centered" id="detail" tabindex="-1" aria-hidden="true">
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class="modal-content pt-5  pb-15">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="fw-bold">Details intervenant</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <!--begin::Close-->
          <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary"
            data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <i class="ki-duotone ki-cross fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body mx-5" [formGroup]="intervenantForm">
          <div class="bloc-input mb-5">
            <label class="fs-6 fw-semibold mb-2">
              <span class="">Email Personnel</span>
            </label>
            <!--begin::Input-->
            <input type="email" formControlName="email" class="form-control form-control-solid"
              placeholder="Email Personnel" name="personal_email" value="" [readonly]="true" />
            <!--end::Input-->
            <app-feild-error [controlName]="'email'" [control]="intervenantForm.get('email')"></app-feild-error>
          </div>

          <!-- Utilisez *ngIf pour conditionner l'affichage en fonction du type de connexion -->
          <div *ngIf="typeCompany==2; ">
            <!-- Si c'est une ESN, afficher l'email professionnel de l'ESN -->
            <div class="bloc-input mb-5">
              <label class="fs-6 fw-semibold mb-2">
                <span class="">Email professionnel ESN</span>
              </label>
              <input type="email" formControlName="emailProESN" class="form-control form-control-solid"
                placeholder="Email professionnel" name="email" value="" [readonly]="true" />
              <app-feild-error [controlName]="'emailProESN'"
                [control]="intervenantForm.get('emailProESN')"></app-feild-error>
            </div>
          </div>
          <div *ngIf="typeCompany==3;">
            <!-- Si c'est une ESN, afficher l'email professionnel de l'ESN -->
            <div class="bloc-input mb-5">
              <label class="fs-6 fw-semibold mb-2">
                <span class="">Email professionnel Client</span>
              </label>
              <input type="email" formControlName="emailProClient" class="form-control form-control-solid"
                placeholder="Intervenant1@gmail.com" name="email" value="" [readonly]="true" />
              <app-feild-error [controlName]="'emailProClient'"
                [control]="intervenantForm.get('emailProClient')"></app-feild-error>
            </div>
          </div>





          <!--end::Label-->
          <!--begin::Input-->
          <div class="bloc-input mb-5">
            <label class="fs-6 fw-semibold mb-2">Nom</label>
            <input type="text" formControlName="first_name" class="form-control form-control-solid" placeholder="nom"
              name="Nom" [readonly]="true" />
            <app-feild-error [control]="intervenantForm.get('first_name')"></app-feild-error>
          </div>
          <div class="bloc-input mb-5">
            <label class="fs-6 fw-semibold mb-2">Prénom</label>
            <input type="text" formControlName="last_name" class="form-control form-control-solid" placeholder="nom"
              name="Nom" [readonly]="true" />
            <app-feild-error [control]="intervenantForm.get('last_name')"></app-feild-error>
          </div>

          <div class="bloc-input mb-5">
            <label class="fs-6 fw-semibold mb-2">N° tel</label>
            <div class="wrapper phone-number" [formGroup]="phoneForm">
              <ngx-intl-tel-input [cssClass]="'form-control'"
                  [searchCountryPlaceholder]="'Rechercher un pays'"
              [preferredCountries]="isPhoneEnabled ? preferredCountries : []"
              [enableAutoCountrySelect]="true" 
              [enablePlaceholder]="false" 
              [searchCountryFlag]="true"
              [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
              ]" 
              [selectFirstCountry]="false" 
              [selectedCountryISO]="CountryISO.France" 
              [maxLength]="10"
              [phoneValidation]="true" 
              [separateDialCode]="separateDialCode"
              [numberFormat]="PhoneNumberFormat.National" 
              name="phone"  
              formControlName="phone" 
              (mousedown)="disableEvent($event)" 
              (keydown)="disableEvent($event)">
          </ngx-intl-tel-input>
          

        
            </div>

            <div class="bloc-input mb-5">
              <!--begin::Label-->
              <label class="fs-6 fw-semibold mb-2">Rôle</label>
              <!--end::Label-->
              <!--begin::Input-->
                      <ng-select formControlName="employee_role_id" [items]="listRole" bindLabel="name" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                [placeholder]="'Rôle'" autoComplete></ng-select>
 </div>


            <!--end::Modal body-->
          </div>
          <!--end::Modal content-->
        </div>
        <!--end::Modal dialog-->
      </div>
    </div>
  </ng-template>
  <ng-template #modifier>
    <div class="modal-dialog-centered" id="modifier" tabindex="-1" aria-hidden="true">
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class="modal-content pt-5  pb-15">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="fw-bold">Modifier Intervenant</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <!--begin::Close-->
          <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary"
            data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <i class="ki-duotone ki-cross fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body mx-5" [formGroup]="intervenantForm">
          <div class="bloc-input mb-5">
            <label class="required fs-6 fw-semibold mb-2">Nom</label>
            <input type="text" formControlName="first_name" class="form-control form-control-solid" placeholder="nom"
              name="Nom" [readonly]="true"/>
        
          </div>
          <div class="bloc-input mb-5">
            <label class="required fs-6 fw-semibold mb-2">Prénom</label>
            <input type="text" formControlName="last_name" class="form-control form-control-solid" placeholder="nom"
              name="Nom" [readonly]="true"/>
   
          </div>
          <div class="bloc-input mb-5">
            <!--begin::Label-->

            <label class="required fs-6 fw-semibold mb-2">
              <span class="">Email personnel</span>
            </label>
            <!--end::Label-->
            <!--begin::Input-->
            <input type="email" #inputField formControlName="email" class="form-control form-control-solid"
              placeholder="Email personnel" name="email" value="" [attr.readonly]="isReadOnly"/>
           </div>
       
         
 
            <div class="bloc-input mb-5" *ngIf="typeCompany==2;">
              <label class="fs-6 fw-semibold mb-2">
                <span class="">Email professionnel ESN</span>
              </label>
              <input type="email" formControlName="emailProESN" class="form-control form-control-solid"
                placeholder="Email professionnel esn" name="email" value="" />
              <app-feild-error [controlName]="'emailProESN'"
                [control]="intervenantForm.get('emailProESN')"></app-feild-error>
                <div *ngIf="intervenantForm.get('emailProESN')?.hasError('pattern') && intervenantForm.get('emailProESN')?.touched"
                class="text-danger">
                La valeur de ce champ doit avoir une adresse email valide.
              </div> 
            </div>

            <div class="bloc-input mb-5" *ngIf="typeCompany==3;">
              <label class="fs-6 fw-semibold mb-2">
                <span class="">Email professionnel Client</span>
              </label>
              <input type="email" formControlName="emailProClient" class="form-control form-control-solid"
                placeholder="Email professionnel client" name="email" value="" />
              <app-feild-error [controlName]="'emailProClient'"
                [control]="intervenantForm.get('emailProClient')"></app-feild-error>
                <div *ngIf="intervenantForm.get('emailProClient')?.hasError('pattern') && intervenantForm.get('emailProClient')?.touched"
                class="text-danger">
                La valeur de ce champ doit avoir une adresse email valide.
              </div> 
            </div>
        
    
          <div class="bloc-input mb-5">
            <label for="prenom">linkedin</label>



        <input type="text" name="linkedin" id="linkedin" 
        class="form-control form-control-solid mb-3" placeholder="https://www.linkedin.com/in/" 
        formControlName="linkedin_link" (input)="setValidatorRequirements()" >

        <div *ngIf="intervenantForm.get('linkedin_link')?.hasError('pattern') && intervenantForm.get('linkedin_link')?.touched" class="text-danger">
              Entrer une URL valide exemple: https://www.linkedin.com/in/exemple
        </div>
      </div>

          <div class="bloc-input mb-5">
            <div class="flex_input">
              <div class="w-100">
                  <div class="labels">
                      <label for="cv" > Importer CV</label>
                      <button *ngIf="showResetButtons && fileName !== '' && !iscv" class="more-label"
                      (click)="resetCV()">
                      <img src="assets/media/icons/icon-delete.png" alt="" width="30px"
                          class="cursor-pointer">
                  </button>
                  </div>
              </div>
              <input  id="fileInput" #inputFile type="file" name="cv" id="cv" 
              (change)="uploadFile($event);setValidatorRequirements()" class="form-control mb-3">
  
              <span style="color:red" *ngIf="fileError"><small>{{fileError}} </small></span>
              <span style="color:red" *ngIf="fileExtention"><small>{{fileExtention}} </small></span>
              <label>Le cv doit être (.pdf,.doc,.docx) </label><br>
  
        
  
          </div>


          </div>
          <div class="bloc-input mb-5">
         
            <label class="fw-semibold mb-2">N° tel</label>
            <div class="wrapper phone-number"  [formGroup]="phoneForm">
              <ngx-intl-tel-input [cssClass]="'form-control disabled-input'" [preferredCountries]="preferredCountries"
                  [searchCountryPlaceholder]="'Rechercher un pays'"
                  [enableAutoCountrySelect]="true" [enablePlaceholder]="false" [searchCountryFlag]="true"
                  [searchCountryField]="[
                      SearchCountryField.Iso2,
                      SearchCountryField.Name
                  ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [maxLength]="10" [phoneValidation]="true"
                  [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National" name="phone"
                  formControlName="phone" (mousedown)="disableEvent($event)" (keydown)="disableEvent($event)">
              </ngx-intl-tel-input>
          </div>
          </div>
            <div class="bloc-input mb-5">
              <!--begin::Label-->
              <label class="required fs-6 fw-semibold mb-2">Rôle</label>
    
              <ng-select formControlName="employee_role_id" [items]="listRole" bindLabel="name" bindValue="id" [notFoundText]="'Aucun élément trouvé'"
                [placeholder]="'Rôle'" autoComplete></ng-select>

              <app-feild-error [control]="intervenantForm.get('employee_role_id')"></app-feild-error>
              <!--end::Input-->
            </div>
            <div class="bloc-input mb-5">
              <label for="fin">Date signature de contrat</label>
              <input type="date" formControlName="date_signature" id="date_signature" class="form-control mb-5">
              <div
                *ngIf="intervenantForm.get('date_signature')?.hasError('required') && intervenantForm.get('date_signature')?.touched"
                class="text-danger">
                Le champ est obligatoire.
              </div>
            </div>
            <div class="modal-footer mx-5">
              <div class="actions">
                <a (click)="closeModal()" class="annuler" style="cursor: pointer;">Annuler</a>
                <button type="submit" data-bs-dismiss="modal"    [disabled]=" intervenantForm.get('employee_role_id')?.invalid ||intervenantForm.get('emailProESN')?.invalid 
                || intervenantForm.get('linkedin_link')?.invalid" (click)="updateIntervenant()"
                  id="kt_modal_add_customer_submit" class="footer-btn confirmer ms-auto">
                  <span class="indicator-label">Modifier</span>
                  <span class="indicator-progress">Please wait...
                    <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                </button>
              </div>
            </div>


            <!--end::Modal body-->
     
          <!--end::Modal content-->
        </div>
        <!--end::Modal dialog-->
      </div>
    </div>
  </ng-template>